import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { IsNullOrEmpty } from "../../helpers/utility";
import { getAccessToken, getisLoading } from "../../store/user/user.selector";
import UserAPI from "../../store/user/user.api";
import Authentication from "./authentication";
import Swal from "sweetalert2";
import { forgotPasswordRequest } from "../../store/user/user.actions";
import {
    Box,
    Button,
    Grid,
    InputAdornment,
    TextField,
    Typography,
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";

function ForgotPassword() {
    const location = useLocation();
    const [userName, setUserName] = useState(undefined);
    const [password, setPassword] = useState(undefined);
    const [otp, setOTP] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [visible, setVisible] = useState(false);
    const [cVisible, setCVisible] = useState(false);
    const [showAuthenticate, setAuthenticate] = useState(false);
    const [param, setParam] = useState({});
    const [cpassword, setCpassword] = useState("");
    const dispatch = useDispatch();
    const history = useNavigate();
    const { accessToken, isLoading } = useSelector((state) => {
        return {
            accessToken: getAccessToken(state),
            isLoading: getisLoading(state),
        };
    });

    useEffect(() => {
        if (location && location.state && location.state.userName) {
            setUserName(location.state.userName);
        }
    }, [location]);

    useEffect(() => {
        let token = sessionStorage.getItem(process.env.REACT_APP_AUTH_TOKEN);
        if (!IsNullOrEmpty(token)) {
            history("/");
        }
    }, [accessToken]);

    const goToSignIn = (e) => {
        e.preventDefault();
        history("/login");
    };

    const changePassword = () => {
        dispatch(
            forgotPasswordRequest({
                account: userName,
                otp: otp,
                newPassword: password,
                confirmPassword: cpassword,
            })
        );
    };

    const handleForgetPassword = () => {
        UserAPI.SendOTP({
            account: userName,
        })
            .then((x) => {
                setParam(x.data);
                setAuthenticate(true);
            })
            .catch((err) => {
                Swal.fire({
                    title: "Send OTP",
                    text: err.response.data.message,
                    icon: "error",
                    showCancelButton: true,
                    cancelButtonColor: "#d33",
                    showConfirmButton: false,
                    cancelButtonText: "Close",
                    customClass: {
                        cancelButton: "order-1 right-gap",
                        confirmButton: "order-2",
                        denyButton: "order-3",
                    },
                });
            });
    };

    const validate = () => {
        if (!showPassword) {
            return IsNullOrEmpty(userName);
        } else {
            return !(
                !IsNullOrEmpty(userName) &&
                !IsNullOrEmpty(password) &&
                !IsNullOrEmpty(cpassword) &&
                !IsNullOrEmpty(otp) &&
                password === cpassword
            );
        }
    };

    if (showAuthenticate) {
        return (
            <Authentication
                showpop={true}
                id={param.id}
                mode={param.mode}
                type={"Phone/Email"}
                data={{
                    account: userName,
                    newPassword: password,
                    confirmPassword: cpassword,
                }}
                onConfirm={(otp) => {
                    setAuthenticate(false);
                    setShowPassword(true);
                    setOTP(otp);
                }}
                onClose={() => {
                    setAuthenticate(false);
                    setShowPassword(false);
                    setOTP("");
                }}
            />
        );
    }

    const isValid = validate();
    return (
        <div className="center-div-h">
            {showPassword ? (
                <div>
                    <h4 className="text-bold mb-4">Enter my new password</h4>
                </div>
            ) : (
                <Box textAlign={"center"} className="mb-4">
                    <Typography variant="h4" component={"h4"}>
                        Forgot Password
                    </Typography>
                    <Typography variant="p" component={"span"}>
                        A code will be sent to you in order for you to reset the
                        password
                    </Typography>
                </Box>
            )}

            {showPassword ? (
                <>
                    <Grid container spacing={2} className="mt-4">
                        <Grid item sm={12} xs={12}>
                            <TextField
                                variant="outlined"
                                type={visible ? "text" : "password"}
                                fullWidth
                                label="Password"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => {
                                    setPassword(e.target.value);
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            {visible ? (
                                                <Visibility
                                                    onClick={() =>
                                                        setVisible(!visible)
                                                    }
                                                />
                                            ) : (
                                                <VisibilityOff
                                                    onClick={() =>
                                                        setVisible(!visible)
                                                    }
                                                />
                                            )}
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        <Grid item sm={12} xs={12}>
                            <TextField
                                variant="outlined"
                                type={cVisible ? "text" : "password"}
                                fullWidth
                                label="Confirm Password"
                                value={cpassword}
                                onChange={(e) => {
                                    setCpassword(e.target.value);
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            {cVisible ? (
                                                <Visibility
                                                    onClick={() =>
                                                        setCVisible(!cVisible)
                                                    }
                                                />
                                            ) : (
                                                <VisibilityOff
                                                    onClick={() =>
                                                        setCVisible(!cVisible)
                                                    }
                                                />
                                            )}
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                    </Grid>
                </>
            ) : (
                <TextField
                    variant="outlined"
                    fullWidth
                    label="Username, email or phone number"
                    placeholder="Username, email or phone number"
                    value={userName}
                    onChange={(e) => {
                        setUserName(e.target.value);
                    }}
                />
            )}
            <Button
                color="primary"
                variant="contained"
                fullWidth
                className="my-4"
                disabled={validate()}
                onClick={() =>
                    showPassword ? changePassword() : handleForgetPassword()
                }
            >
                {showPassword ? "Save" : "Find My Account"}
            </Button>
        </div>
    );
}

export default ForgotPassword;
